import { useMutation } from "react-query";
import { addHomeCompany } from "actions/Utilities/HomeCompany";
import { toast } from "components/toastNotification";
import { IHomeCompany } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateHomeCompany,
  homeCompanyReFetching,
} from "../atoms/atoms";

export default function useAddHomeCompany () {
  const setIsAddState = useSetRecoilState(addStateHomeCompany);
  const [isReFetching, setIsReFetching] = useRecoilState(
    homeCompanyReFetching
  );

  const { mutate } = useMutation(
    (NewData: IHomeCompany) => addHomeCompany(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Home Company failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Home Company Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Home Company Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Home Company failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Home Company failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Home Company failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Home Company failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};

